import { ca } from '@cian/analytics';

interface IFavoriteButtonTracking {
  isFavorite: boolean;
  label: string;
}

export function trackFavoriteClick({ isFavorite, label }: IFavoriteButtonTracking) {
  ca('eventSite', {
    action: isFavorite ? 'remove_from_card_fullscreen_gallery' : 'add_from_card_fullscreen_gallery',
    category: 'favorite',
    label,
    name: 'oldevent',
    useLastProducts: true,
  });
}
